<div class="add-comment-page">
    <header class="pt-5 text-center text-secondary container">
        <h1 class="pb-1 fs-3 fw-normal">
            {{'add_comment' | translate}}
        </h1>
        <p class="col-md-4 mx-auto">{{'add_comment_informations_share_team' | translate}}</p>
        <hr class="w-25 mx-auto pt-2">
    </header>

    
    <div id="container" class="container">
        @if(moods){
            <div class="row">
                <form class="form mt-4 col-md-9 mx-auto">
                    @for(mood of moods; track mood.id){
                        @if(mood.id === teamNavigation.currentMoodId){
                            <div class="mb-5 pb-0">
                                <div class="d-md-flex flex-row-reverse justify-content-between align-items-baseline pb-3 text-secondary">
                                    <p class="text-end">
                                        @if(moods.length > 1){
                                            <span>{{ 'add_comment.team' | translate}} {{teamNavigation.currentTeamIndex + 1}} {{ 'add_comment.of' | translate}} {{moods.length}}</span>
                                        }
                                    </p>
                                    <h2 class="fs-4">{{mood.teamName}}</h2>
                                </div>
                                
                                <add-mood [mood]="mood"
                                          [previousComment]="$safeNavigationMigration(moods[$index - 1]?.comment?.body)"></add-mood>
            
                                <div class="text-end">
                                    @if(moods.length > 1 && moods.indexOf(mood) > 0){
                                        <button class="btn btn-primary py-2 px-3 me-1" (click)="previous()">
                                            <i class="far fa-chevron-left ps-2"></i> {{'add_comment_next.previous' | translate}}
                                        </button>
                                    }
                                    <button class="btn btn-primary py-2 px-3" data-cy="next-btn" (click)="next()">
                                        @if(moods.indexOf(mood) < moods.length - 1){
                                            <span>
                                                {{ 'add_comment_next.continue' | translate }} <i class="far fa-chevron-right ps-2"></i>
                                            </span>
                                        }
                                        @if(moods.indexOf(mood) === moods.length - 1){
                                            <span>
                                                {{ 'add_comment_next.next' | translate }} <i class="far fa-chevron-right ps-2"></i>
                                            </span>
                                        }
                                    </button>
                                </div>
                                @if(moods.length > 1 && (moods.indexOf(mood) < moods.length - 1)){
                                    <div class="text-end skip-nav">
                                        <button class="border-0 bg-transparent p-2 text-secondary fst-italic" data-cy="skip-btn" 
                                                (click)="skip()">
                                                {{'add_comment.skip' | translate}} <i class="fa-solid fa-chevrons-right ps-2"></i>
                                        </button>
                                    </div>
                                }
                                <div class="row mt-0 mx-auto mb-3 row gx-5 informations">
                                    <div class="media col-md-6 d-flex">
                                        <i class="far fa-mask fa-4x" aria-hidden="true"></i>
                                        <div class="media-body px-3">
                                            <h4 class="media-heading">{{'add_comment_anonymous' | translate}}</h4>
                                            <p>{{'add_comment_information_anonymous' | translate}}</p>
                                        </div>
                                    </div>
                                    <div class="media col-md-6 d-flex">
                                        <i class="far fa-comment fa-4x" aria-hidden="true"></i>
                                        <div class="media-body px-3">
                                            <h4 class="media-heading">{{'add_comment_civil' | translate}}</h4>
                                            <p>
                                                {{'add_comment_informations_disclaimer' | translate}}
                                                <a href="/{{mood.teamId}}/codeofconduct" target="_blank">{{'add_mood_box.code_of_conduct' | translate}}</a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    }
                </form>
            </div>
        }
        
    </div>
</div>